import { AutomaticVerificationSingleTabProps, Headers, TypeOfCard } from "./types/automaticVerificationModalProps";
import './automaticVerificationModal.scss';
import { AdditionalIcon } from "../../../../../components/shared/additionalIcon/additionalIcon";
import { ReactComponent as ErrorIcon } from "../../../../../icons/error.svg";
import { ReactComponent as EmergencyHome } from "../../../../../icons/emergency_home.svg";
import { ReactComponent as CheckCircle } from "../../../../../icons/check_circle.svg";
import ButtonField from "../../../../../components/buttonField/buttonField";
import { classNameBtn } from "../../../../../components/shared/button/types/buttonProps";
import { ButtonFieldProps } from "../../../../../components/buttonField/types/buttonFieldProps";
import { EndangeredAreaGminyAttributes, HeadlineNamesKRO, HeadlineNamesKRPO, HeadlineNamesKRTZ, KrEndangeredAreaFormTypes, KrLandslideFormTypes, LandslideGminyAttributes, SortedArrayKROAttributes, endangeredAreaAttributes, labelKrForm2007, labelKrForm2020, labelKrPO, landSlideAttributes, sortedKrPO } from "../../../../../contexts/krFormContext";
import { ProtocolAttributes, poFormTypes } from "../../../../../contexts/poFormContext";
import Table from "../../../../../components/shared/table/table";
import { TableProps } from "../../../../../components/shared/table/types/tableProps";
import { HeadersTable } from "../../../../../helpers/featureTableConstruct";
import { createColumnHelper } from "@tanstack/react-table";
import FormField from "../../../../../components/formField/formField";
import { FormFieldProps } from "../../../../../components/formField/types/formFieldProps";
import { styleFormFieldOnThree } from "../../../../../components/shared/stylization";
import { padZeros } from "../../../../../helpers/idNumber";
import { useContext } from "react";
import ViewContext from "../../../../../contexts/viewContext";
import { ObjectType } from "../../../../../contexts/types/card";
import PermissionsContext from "../../../../../contexts/permissionsContext";
import { canBeEdited, canBeVerified, checkAssigment } from "../../../../../helpers/permissionsHelper";
import { GetOptions } from "../../../../../helpers/prepareForSelect";
import AuthContext from "../../../../../contexts/authContext";

const EMPTY_VALUE = "";

const AutomaticVerificationSingleTab = (props: AutomaticVerificationSingleTabProps) => {
    const { setViewType, setViewData, viewTypes } = useContext(ViewContext);
    const { userRoles, username } = useContext(AuthContext);
    const { functionsPermissions, extendedUserPermissions } = useContext(PermissionsContext);

    const Errors = !props.card?.config?.isValid
    const Warnings = props.type === TypeOfCard.landslide ? !props.card?.config?.isValidWarnings : false;

    const middleCheckAttributes = () => {
        let keys = Object.keys(props.card?.config?.ValidationError!) as Array<string>;
        let isValid: boolean = true;
        keys.forEach((key) => {
            if (props.card?.config?.ValidationError![key] !== "" &&
                props.card?.config?.ValidationError![key] !== undefined && props.card?.config?.ValidationError![key] !== null) {
                    isValid = false;
            }
        })
        return isValid;
    }

    const middleVerify = middleCheckAttributes();

    const ButtonOnClick = (e: any, waitingRoomGID: string | undefined) => {
        if (props.rows) {
            var row = props.rows.find((row) => {
                return props.triggeredFromLocal ? row.original.GLOBALID === waitingRoomGID : row.original.attributes.GLOBALID === waitingRoomGID
            })?.original;
            if (row) {
                props.triggeredFromLocal ? handleEditClickFromLocalTab(row) : handleEditClickFromWaitingTab(row);
            }
        }
    }

    const handleEditClickFromLocalTab = (row: any) => {
        var rowCorrect = {
            attributes: row
        }
        const waitingroom = rowCorrect.attributes;
        const objectType: ObjectType = waitingroom.RODZAJ_OBIEKTU;
        const objectStatus = waitingroom.STAN_OBIEKTU_DOM;
        var isKR = objectType === ObjectType.KRO || objectType === ObjectType.KRTZ;

        const assignedUser = waitingroom.PRZYPISANY_UZYTKOWNIK;
        const isAssigment = checkAssigment(username, assignedUser, userRoles);

        if (isAssigment && canBeEdited(functionsPermissions, waitingroom, extendedUserPermissions, false, true)) {
            if (isKR) {
                setViewData({ row: rowCorrect, editMode: true, local: true });
                setViewType(viewTypes.KRForm);
            }
            else {
                setViewData({ row: rowCorrect, local: true});
                setViewType(viewTypes.POForm);
            }
        }
        else if (isAssigment && canBeVerified(functionsPermissions, objectStatus)) {
            setViewData({ row: rowCorrect, editMode: false, local: true });
            setViewType(viewTypes.KRForm);
        }
    }

    const handleEditClickFromWaitingTab = (row: any) => {
        const waitingroom = row.attributes;
        const objectType: ObjectType = waitingroom.RODZAJ_OBIEKTU;
        const objectStatus = waitingroom.STAN_OBIEKTU_DOM;
        var isKR = objectType === ObjectType.KRO || objectType === ObjectType.KRTZ;

        const assignedUser = waitingroom.PRZYPISANY_UZYTKOWNIK;
        const isAssigment = checkAssigment(username, assignedUser, userRoles);

        if (isAssigment && canBeEdited(functionsPermissions, waitingroom, extendedUserPermissions, undefined, true)) {
            if (isKR) {
                setViewData({ row: row, editMode: true, local: false });
                setViewType(viewTypes.KRForm);
            }
            else {
                setViewData({ row: row, local: false});
                setViewType(viewTypes.POForm);
            }
        }
        else if (isAssigment && canBeVerified(functionsPermissions, objectStatus)) {
            if (objectType === ObjectType.KRO || objectType === ObjectType.KRTZ) {
                setViewData({ row: row, editMode: false, local: false });
                setViewType(viewTypes.KRForm);
            }
        }
    }

    const getBtnProps = (title: string, btnClass: string, waitingRoomGID: string | undefined): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: (event: any) => { ButtonOnClick(event, waitingRoomGID) },
                className: `${classNameBtn.Btn} ${btnClass} btn body-txt-medium`
            },
            placeHolder: title
        };
    }

    const sortRowsByFieldKR = (rows: Headers[], labelCard: Record<string, string>) => {
        var sortedLabels = SortedArrayKROAttributes();
        return _sortRowsBy(rows, labelCard, sortedLabels);
    }

    const sortRowsByFieldPO = (rows: Headers[], labelCard: Record<string, string>) => {
        var sortedLabels = sortedKrPO();
        return _sortRowsBy(rows, labelCard, sortedLabels);
    }

    const _sortRowsBy = (rows: Headers[], labelCard: Record<string, string>, sortedLabels: string[]) => {
        if (rows) {
            const fieldOrder2 = sortedLabels;
            var sortedRows: Headers[] = [];
            fieldOrder2.forEach((field) => {
                if (field === "roadDamages") {
                    var foundRoadDamages = rows.filter((row => row.pole === labelCard[field]));
                    if (foundRoadDamages) {
                        sortedRows = sortedRows.concat(foundRoadDamages);
                    }
                }
                else {
                    var found = rows.find((row) => {
                        return row.pole === labelCard[field];
                    })
                    if (found) {
                        sortedRows.push(found);
                    }
                }
            })
            return sortedRows;
        }
        else {
            return rows;
        }
    }

    const addZeros = (element: string) => {
        if (element.length === 1) return "0" + element;
        return element;
    }

    const _prepareDate = (value: any) => {
        let _date = Number(value);
        if (!isNaN(_date)) {
            let date = new Date(new Date(_date).setHours(0, 0, 0, 0));
            let day = addZeros(date.getDate().toString());
            let month = addZeros((date.getMonth() + 1).toString());
            return date.getFullYear() + "-" + month + "-" + day;
        }
        return value; 
    }

    const _isEmpty = (value: any) => {
        return value === undefined || value === null || value === "";
    }

    const createTableLandslide = () => {
        var cardLandslide = props.card as KrLandslideFormTypes;
        return _createLandslideTable(cardLandslide, cardLandslide?.config?.ValidationError!);
    }

    const createTableLandslideWarning = () => {
        var cardLandslide = props.card as KrLandslideFormTypes;
        return _createLandslideTable(cardLandslide, cardLandslide?.config?.ValidationWarningsError!);
    }

    const _createLandslideTable = (cardLandslide: KrLandslideFormTypes, errors: Record<string, string>) => {
        let labelCard2007 = labelKrForm2007();
        let labelCard2020 = labelKrForm2020();
        let HeadlineCard = HeadlineNamesKRO();
        let rows: Headers[] = []
        if (errors) {
            const keys = Object.keys(errors) as Array<string>;
            var landslideKeys = Object.keys(cardLandslide?.landslideAttributes!) as Array<string>;
            keys.forEach((key) => {
                var row: Headers = {};
                if (_isEmpty(errors[key]) === false) {
                    if (key.includes("roadDamages") ? true : landslideKeys.includes(key)) {
                        let currentValue: string = "";
                        if (key.includes("roadDamages") && cardLandslide.landslideRoadDamages && props.dictionariesForValidation) {
                            var idx = key.slice(-1);
                            var dictIdx = cardLandslide.landslideRoadDamages[Number(idx)].infrastrukturA_KOM_SID;
                            var dict = GetOptions("INFRASTRUKTURA_KOMUNIKACYJNA", props.dictionariesForValidation);
                            var val = dict?.find(item => item.value === dictIdx)?.name;
                            if (val !== undefined) currentValue = val;
                        }
                        else {
                            currentValue = cardLandslide.landslideAttributes![key as keyof landSlideAttributes]?.toString();
                        }
                        if (_isEmpty(currentValue)) {
                            row.wpisanaWartosc = EMPTY_VALUE;
                        } else {
                            if (key === "datA_WYPELNIENIA" || key === "datA_USTALENIA") {
                                row.wpisanaWartosc = _prepareDate(currentValue);
                            } else if (key === "miejscowosC_NAZWA") {
                                row.wpisanaWartosc = EMPTY_VALUE;
                            } else if (key === "czY_MONITORING" || key === "czY_MONITORING_POWIERZCHNIOWY" || key === "czY_MONITORING_WGLEBNY") {
                                // row.wpisanaWartosc = currentValue === 1 || currentValue === "1" ? "tak" : "nie";
                                row.wpisanaWartosc = currentValue === "1" ? "tak" : "nie";
                            } else {
                                row.wpisanaWartosc = currentValue;
                            }
                        }
                    } else {
                        row.wpisanaWartosc = EMPTY_VALUE;
                    }

                    if (cardLandslide.landslideAttributes!.wersja === 1) {
                        row.pole = labelCard2007![key];
                        if (key.includes("roadDamages")) row.pole = labelCard2007!["roadDamages"];
                    } else {
                        row.pole = labelCard2020![key];
                        if (key.includes("roadDamages")) row.pole = labelCard2020!["roadDamages"];
                    }
                    row.komunikat = errors[key];
                    var valuesHeadlines = Object.values(HeadlineCard)
                    var keysHeadlines = Object.keys(HeadlineCard);
                    for (var i = 0; i < valuesHeadlines.length; i++) {
                        if (key.includes("roadDamages") ? valuesHeadlines[i].includes("roadDamages") : valuesHeadlines[i].includes(key)) {
                            // eslint-disable-next-line no-loop-func
                            row.zakladka = keysHeadlines.find((key, index) => {
                                return index === i
                            });
                        }
                    }
                    rows.push(row);
                }
            });
        }
        rows = sortRowsByFieldKR(rows, cardLandslide.landslideAttributes!.wersja === 1 ? labelCard2007 : labelCard2020);
        return rows;
    }

    const createTableProtocol = () => {
        var cardProtocol = props.card as poFormTypes;
        return _createTableProtocol(cardProtocol, cardProtocol?.config?.ValidationError!);
    }

    const createTableProtocolWarnings = () => {
        var cardProtocol = props.card as poFormTypes;
        return _createTableProtocol(cardProtocol, cardProtocol?.config?.ValidationWarningsError!);
    }

    const _createTableProtocol = (cardProtocol: poFormTypes, errors: Record<string, string>) => {
        let labelCard = labelKrPO();
        let HeadlineCard = HeadlineNamesKRPO();
        let rows: Headers[] = [];
        if (errors) {
            const keys = Object.keys(errors) as Array<string>;
            var endangeredKeys = Object.keys(cardProtocol?.protocolAttributes!) as Array<string>;
            keys.forEach((key) => {
                var row: Headers = {};
                if (_isEmpty(errors[key]) === false) {
                    if (endangeredKeys.includes(key)) {
                        let currentValue = cardProtocol.protocolAttributes![key as keyof ProtocolAttributes]?.toString();
                        if (_isEmpty(currentValue)) {
                            row.wpisanaWartosc = EMPTY_VALUE;
                        } else if (key === "datA_OBS" || key === "datA_PROT") {
                            row.wpisanaWartosc = _prepareDate(currentValue);
                        } else {
                            row.wpisanaWartosc = currentValue;
                        }
                    }
                    row.komunikat = errors[key];
                    row.pole = labelCard![key];
                    var valuesHeadlines = Object.values(HeadlineCard)
                    var keysHeadlines = Object.keys(HeadlineCard);
                    for (var i = 0; i < valuesHeadlines.length; i++) {
                        if (valuesHeadlines[i].includes(key)) {
                            // eslint-disable-next-line no-loop-func
                            row.zakladka = keysHeadlines.find((key, index) => {
                                return index === i
                            });
                        }
                    }
                    rows.push(row);
                } else {
                    row.wpisanaWartosc = EMPTY_VALUE;
                }
            });
        }
        rows = sortRowsByFieldPO(rows, labelCard);
        return rows;
    }

    const createTableEndangeredArea = () => {
        var cardEndangeredArea = props.card as KrEndangeredAreaFormTypes;
        return _createTableEndangeredArea(cardEndangeredArea, cardEndangeredArea?.config?.ValidationError!);
    }

    const createTableEndangeredAreaWarnings = () => {
        var cardEndangeredArea = props.card as KrEndangeredAreaFormTypes;
        return _createTableEndangeredArea(cardEndangeredArea, cardEndangeredArea?.config?.ValidationWarningsError!);
    }

    const _createTableEndangeredArea = (cardEndangeredArea: KrEndangeredAreaFormTypes, errors: Record<string, string>) => {
        let rows: Headers[] = [];
        let labelCard2007 = labelKrForm2007();
        let labelCard2020 = labelKrForm2020();
        let HeadlineCard = HeadlineNamesKRTZ();
        if (errors) {
            const keys = Object.keys(errors) as Array<string>;
            var endangeredKeys = Object.keys(cardEndangeredArea?.endangeredAreaAttributes!) as Array<string>;
            keys.forEach((key) => {
                var row: Headers = {};
                if (_isEmpty(errors[key]) === false) {
                    if (endangeredKeys.includes(key)) {
                        let currentValue = cardEndangeredArea.endangeredAreaAttributes![key as keyof endangeredAreaAttributes]?.toString();
                        if (_isEmpty(currentValue)) {
                            row.wpisanaWartosc = EMPTY_VALUE;
                        } else {
                            if (key === "datA_WYPELNIENIA" || key === "datA_USTALENIA") {
                                row.wpisanaWartosc = _prepareDate(currentValue);
                            } else if (key === "miejscowosC_NAZWA") {
                                row.wpisanaWartosc = EMPTY_VALUE;
                            } else {
                                row.wpisanaWartosc = currentValue;
                            }
                        }
                    }
                    row.komunikat = errors[key];
                    if (cardEndangeredArea.endangeredAreaAttributes!.wersjA_KARTY === 1) {
                        row.pole = labelCard2007![key];
                    } else {
                        row.pole = labelCard2020![key];
                    }
                    var valuesHeadlines = Object.values(HeadlineCard)
                    var keysHeadlines = Object.keys(HeadlineCard);
                    for (var i = 0; i < valuesHeadlines.length; i++) {
                        if (valuesHeadlines[i].includes(key)) {
                            // eslint-disable-next-line no-loop-func
                            row.zakladka = keysHeadlines.find((key, index) => {
                                return index === i
                            });
                        }
                    }
                    rows.push(row);
                } else {
                    row.wpisanaWartosc = EMPTY_VALUE;
                }
            });
        }
        rows = sortRowsByFieldKR(rows, labelCard2020);
        return rows;
    }

    var Headers: Headers = {
        zakladka: "Zakładka",
        pole: "Pole",
        wpisanaWartosc: "Wpisana wartość",
        komunikat: "Komunikat"
    }

    var columns = Object.keys(Headers);

    const prepareData = () => {
        if (props.type === TypeOfCard.landslide) return createTableLandslide();
        if (props.type === TypeOfCard.endangeredArea) return createTableEndangeredArea();
        if (props.type === TypeOfCard.protocol) return createTableProtocol();
        var row: Headers[] = [];
        return row;
    }

    const prepareDataWarning = () => {
        if (props.type === TypeOfCard.landslide) return createTableLandslideWarning();
        if (props.type === TypeOfCard.endangeredArea) return createTableEndangeredAreaWarnings();
        if (props.type === TypeOfCard.protocol) return createTableProtocolWarnings();
        var row: Headers[] = [];
        return row;
    }

    var tableProps: TableProps = {
        columnAliases: Headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: columns,
        cellActions: undefined,
        data: prepareData(),
        extraSelection: undefined,
        selection: undefined,
        onTrClick: undefined,
        rowCompare: undefined,
        loading: false,
        firstColumnCheckbox: false,
        tableFiltersVisible: false,
        threeDots: false
    }

    var tablePropsWarnings: TableProps = {
        columnAliases: Headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: columns,
        cellActions: undefined,
        data: prepareDataWarning(),
        extraSelection: undefined,
        selection: undefined,
        onTrClick: undefined,
        rowCompare: undefined,
        loading: false,
        firstColumnCheckbox: false,
        tableFiltersVisible: false,
        threeDots: false
    }

    let idNumber: number | string | undefined = "";

    const setIdNumber = () => {
        if (props.type === 1) {
            idNumber = padZeros((props.card as KrLandslideFormTypes).landslideAttributes?.numeR_IDENTYFIKACYJNY!);
        }
        if (props.type === 2) {
            idNumber = padZeros((props.card as KrEndangeredAreaFormTypes).endangeredAreaAttributes?.numeR_IDENTYFIKACYJNY!);
        }
        if (props.type === 3) {
            idNumber = (props.card as poFormTypes).protocolAttributes?.obiekT_NUMER_IDENTYFIKACYJNY!;
        }
    }

    setIdNumber();

    const getNumerRoboczy = () => {
        if (props.type === 1 && (props.card as KrLandslideFormTypes).landslideAttributes?.numeR_ROBOCZY) {
            return (props.card as KrLandslideFormTypes).landslideAttributes?.numeR_ROBOCZY!;
        }
        if (props.type === 2 && (props.card as KrEndangeredAreaFormTypes).endangeredAreaAttributes?.numeR_ROBOCZY) {
            return (props.card as KrEndangeredAreaFormTypes).endangeredAreaAttributes?.numeR_ROBOCZY!;
        }
        if (props.type === 3 && (props.card as poFormTypes).protocolAttributes?.obiekT_NUMER_IDENTYFIKACYJNY) {
            return (props.card as poFormTypes).protocolAttributes?.obiekT_NUMER_IDENTYFIKACYJNY!;
        }
        return "";
    }

    var inputPropsRegistrationNumber: FormFieldProps = {
        labelName: 'ID',
        value: `${idNumber}`,
        style: styleFormFieldOnThree,
        type: "text",
        disabled: true,
        hasTextarea: true
    }

    //this field cannot be validated
    var inputPropsWorkingNumber: FormFieldProps = {
        labelName: 'Roboczy',
        value: `${getNumerRoboczy()}`,
        style: styleFormFieldOnThree,
        type: "text",
        disabled: true,
        hasTextarea: true
    }

    var gmina = "";

    const createFieldsForLocation = () => {
        var gminy = undefined;
        if (props.type === 1) {
            gminy = (props.card as KrLandslideFormTypes).landslideGminy
        }
        if (props.type === 2) {
            gminy = (props.card as KrEndangeredAreaFormTypes).endangeredAreaGminy
        }
        if (props.type === 3) {
            var protocolCard = (props.card as poFormTypes);
            if (protocolCard.protocolAttributes?.tereN_ZAGROZONY_GID != null) {
                gminy = protocolCard.endangeredAreaGminy;
            }
            if (protocolCard.protocolAttributes?.osuwiskO_GID != null) {
                gminy = protocolCard.landslideGminy;
            }
        }
        _createFieldsForLocation(gminy);
    }

    const _createFieldsForLocation = (gminy?: LandslideGminyAttributes[] | EndangeredAreaGminyAttributes[] | undefined) => {
        if (gminy && gminy.length > 0) {
            gmina = gminy[0].gmina as string;
            for (var i = 1; i < gminy?.length; i++) {
                if (!gmina.includes(gminy[i].gmina as string)) gmina += `,\n${gminy[i].gmina}`;
            }
        }
    }

    createFieldsForLocation();

    const getInputProps = (name: string): FormFieldProps => {
        return {
            style: styleFormFieldOnThree,
            type: "text",
            disabled: true
        }
    }

    return (<>
        {(Errors && !middleVerify) ? <div className="titleWithButton">
            {AdditionalIcon(ErrorIcon, { paddingRight: "10px" })}
            <div><b>Walidacja - występują błędy</b></div>
            <div style={{ marginLeft: "auto" }}><ButtonField {...getBtnProps("Przejdź do edycji KR", classNameBtn.Large, props.card?.waitingRoomGlobalId)}></ButtonField></div>
        </div> : undefined}
        {((!Errors || middleVerify) && Warnings) ? <div className="titleWithButton">
            {AdditionalIcon(EmergencyHome, { paddingRight: "10px" })}
            <div><b>Walidacja - występują ostrzeżenia</b></div>
            <div style={{ marginLeft: "auto" }}><ButtonField {...getBtnProps("Przejdź do formularza", classNameBtn.Large, props.card?.waitingRoomGlobalId)}></ButtonField></div>
        </div> : undefined}
        {(!Errors && !Warnings) ? <div className="titleWithButton">
            {AdditionalIcon(CheckCircle, { fill: "green", paddingRight: "10px" })}
            <div><b>Walidacja - nie występują błędy</b></div>
            <div style={{ marginLeft: "auto" }}><ButtonField {...getBtnProps("Przejdź do formularza", classNameBtn.Large, props.card?.waitingRoomGlobalId)}></ButtonField></div>
        </div> : undefined}
        <div className="parametersCard">
            <FormField {...inputPropsRegistrationNumber} />
            <FormField {...inputPropsWorkingNumber} />
            <FormField {...getInputProps("gmina")} labelName="Gmina" value={gmina} hasTextarea={true} />
        </div>
        {props.type === TypeOfCard.landslide &&
            <div className="titleWithButton">
                <Table {...tableProps} />
            </div>
        }
        {props.type === TypeOfCard.endangeredArea &&
            <div className="titleWithButton">
                <Table {...tableProps} />
            </div>}
        {props.type === TypeOfCard.protocol ?
            <div className="titleWithButton">
                <Table {...tableProps} />
            </div> : undefined}
        {props.type === TypeOfCard.landslide &&
            <div className="titleWithButtonWarning">
                <Table {...tablePropsWarnings} />
            </div>
        }
        {props.type === TypeOfCard.endangeredArea &&
            <div className="titleWithButtonWarning">
                <Table {...tablePropsWarnings} />
            </div>}
        {props.type === TypeOfCard.protocol ?
            <div className="titleWithButtonWarning">
                <Table {...tablePropsWarnings} />
            </div> : undefined}
    </>);
}

export default AutomaticVerificationSingleTab;